<template>
  <!--
          作者：luoyiming
          时间：2019-10-24
          描述：统计-销售统计-菜品统计-排行榜
      -->
  <div class="right-box d-s-s d-c">
    <div class="lh30 f16 tl">{{ $t('菜品排行榜') }}</div>
    <div class="ww100 mt10">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane :label="`${$t('销量')}TOP10`" name="sale"></el-tab-pane>
        <el-tab-pane :label="`${$t('销售额')}TOP10`" name="view"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="list ww100">
      <ul v-if="listData.length > 0">
        <li v-for="(item, index) in listData" :key="index" class="d-s-c p-6-0 border-b-d">
          <span class="key-box">{{ index + 1 }}</span>
          <span class="text-ellipsis-2 flex-1 ml10">{{ item.product_name }}</span>
          <span class="gray9 tr" style="width: 200px;">
            <template>
              {{ $t('销量') }}：{{ item.total_num }}
            </template>
            <br>
            <template>
              {{ $t('销售额') }}：€{{ item.total_price }}
            </template>
          </span>
        </li>
      </ul>
      <div v-else class="tc pt30">{{ $t('暂无上榜记录') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: 'sale',
      /*列表数据*/
      listData: [],
      languageFields : {
        "en": "english",
        "it": "italian",
        "de": "german",
        "es": "spanish",
        "fr": "french",
        "hr": "croatia",
        "sl": "slovenia",
        "hu": "hungarian"
      },
    };
  },
  inject: ['dataRank'],
  created() {

  },
  mounted() {
    this.getData()
  },
  methods: {
    getData(){
      const langSelect = localStorage.getItem('lang-select');
      this.listData = this.dataRank.salesMoneyRank;
      // 解析并更新菜品名称
      this.listData.forEach(item => {
        if (item.product_info) {
          const langInfo = JSON.parse(item.product_info);
          const langField = this.languageFields[langSelect];
          if (langInfo[langField] && langInfo[langField].product_name) {
            item.product_name = langInfo[langField].product_name;
          }
        }
      });
    },
    handleClick() {
      const langSelect = localStorage.getItem('lang-select');
      if (this.activeName == 'sale') {
        this.listData = this.dataRank.salesNumRank;
      } else if (this.activeName == 'view') {
        this.listData = this.dataRank.salesMoneyRank;
      }
      this.listData.forEach(item => {
        if (item.product_info) {
          const langInfo = JSON.parse(item.product_info);
          const langField = this.languageFields[langSelect];
          if (langInfo[langField] && langInfo[langField].product_name) {
            item.product_name = langInfo[langField].product_name;
          }
        }
      });
    }
  }
};
</script>

<style scoped="scoped">
.right-box {
  padding: 10px 20px;
  width: 100%;
  box-sizing: border-box;
}

.Echarts>div {
  height: 400px;
}

.right-box .list .key-box {
  width: 20px;
  height: 20px;
  line-height: 20px;
  border-radius: 50%;
  font-weight: bold;
  text-align: center;
  color: #ffffff;
  background: red;
}

.right-box .list img {
  width: 30px;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/part/product/Ranking.vue